// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b77fc4d","455":"2e7690ad","977":"e84312fe"}[chunkId] + ".chunk.js";
};